import { render, staticRenderFns } from "./wangwenguaDetails.vue?vue&type=template&id=07a0a6e9"
import script from "./wangwenguaDetails.vue?vue&type=script&lang=js"
export * from "./wangwenguaDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports